import { ErrorMarkup } from 'modules/error';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { SendingPlatform } from '../../../constants';
import { Wrapper, MainContent } from '../Page.styled';
import { PageHeader } from '../PageHeader';
import { Sidebar } from '../Sidebar';
import { EmailAccountsHeader } from './EmailAccountsHeader';
import { EmailModals } from './EmailModals';
import { EmailAccountsSection } from './EmailAccountsSection';

export const EmailPage = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { hasError, isLoadingEssentialData } = useSendingPlatformsQueryContext();

  if (hasError)
    return (
      <ErrorMarkup
        id="sending-platforms-details-error-page"
        fallbackLinkTo="/settings/sendingPlatforms"
        fallbackLinkToText="Back to Sending Platforms"
      />
    );

  return (
    <>
      <div>
        <PageHeader sendingPlatform={sendingPlatform} />
        <Wrapper>
          <Sidebar sendingPlatform={sendingPlatform} />
          <MainContent>
            <EmailAccountsHeader sendingPlatform={sendingPlatform} />
            <EmailAccountsSection sendingPlatform={sendingPlatform} />
          </MainContent>
        </Wrapper>
      </div>
      {!isLoadingEssentialData && <EmailModals />}
    </>
  );
};
